import { memo } from 'react';
import cx from 'classnames';
import Placeholder from '@components/Placeholder';

const TaskEmptyList = ({ className, type = 'blank', title = null, message }) => {
    const html = `${title ?? ''}<br>${message}`;
    return (
        <div className={cx('c-tel', className)}>
            <Placeholder type={type} />
            <div className="messages" dangerouslySetInnerHTML={{ __html: html }} />
        </div>
    );
};

export default memo(TaskEmptyList);
